import { Stack, Typography } from '@mui/material'

import { PhxIcon } from '@salsita-ai/platform-project-sdk/ui'

export const NonStandardMaterialWarning = () => (
  <Stack direction="row" justifyContent="space-between" sx={{ gap: 1 }}>
    <PhxIcon name="WarningCircleDuotone" />
    <Typography variant="body2" color="warning">
      Selected material is not standard. It may affect delivery time.
    </Typography>
  </Stack>
)
